export default "__VITE_ASSET__054649e0__$_?component__"